import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M12 .375C18.42.375 23.625 5.58 23.625 12S18.42 23.625 12 23.625.375 18.42.375 12 5.58.375 12 .375"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#D9DCDD",
  "stroke-width": ".75",
  d: "M12 .375C18.42.375 23.625 5.58 23.625 12S18.42 23.625 12 23.625.375 18.42.375 12 5.58.375 12 .375Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#414042",
  d: "M15.75 7.625A.625.625 0 0 0 15.125 7h-6.25a.625.625 0 0 0-.625.625V17l2.82-1.611a1.88 1.88 0 0 1 1.86 0l2.82 1.61zM17 17a1.25 1.25 0 0 1-1.87 1.085l-2.82-1.611a.63.63 0 0 0-.62 0l-2.82 1.611A1.25 1.25 0 0 1 7 17V7.625A1.875 1.875 0 0 1 8.875 5.75h6.25A1.875 1.875 0 0 1 17 7.625z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }